import { matchPath } from 'react-router-dom'

import { MenuSection } from '@shared/components/Navigation/menuSections/useMenuSections'

export const stripLocale = (path: string): string => {
  return path.replace(/^\/[a-z]{2}(?=\/)/, '')
}

export const isPathMatch = (currentPath: string, targetPath: string): boolean => {
  return currentPath === targetPath || currentPath.startsWith(targetPath + '/')
}

export const isMenuItemActive = (
  pathname: string,
  itemPath?: string,
  isActionMenu?: boolean
): boolean => {
  if (!itemPath || isActionMenu) return false

  const current = stripLocale(pathname)
  const target = stripLocale(itemPath)

  return isPathMatch(current, target)
}

export const isSidebarItemActive = (
  current: string,
  item: MenuSection,
  hasChildren: boolean
): boolean => {
  if (hasChildren) {
    return !!item.children?.some(
      (child) => child.path && matchPath({ path: stripLocale(child.path), end: false }, current)
    )
  }

  if (item.path) {
    return matchPath({ path: stripLocale(item.path), end: false }, current) !== null
  }

  if (item.id) {
    return current.includes(item.id)
  }

  return false
}
